import React from 'react';
import { ActiveOpenings } from '_organisms';
import { MyActiveCandidates } from '../DashboardHRLead/DashboardHRLead';
import './style.scss';

export const DashboardTeamLead: React.FC = () => (
  <div className="dashboard-team-lead">
    <ActiveOpenings />
    <MyActiveCandidates setTabsLoading={() => {}} />
  </div>
);
